import { render } from "./DetailComponent5.vue?vue&type=template&id=eeb6260c"
import script from "./DetailComponent5.vue?vue&type=script&lang=js"
export * from "./DetailComponent5.vue?vue&type=script&lang=js"

import "./DetailComponent5.vue?vue&type=style&index=0&id=eeb6260c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__